import { api, affiliateApi } from '../lib/axios';

import { AffiliateDetails, UpdateAffiliateDetails } from '../types/affiliate';

export interface ProgramInvitation {
  id: string;
  affiliateId: string | null;
  email: string;
  programId: string;
  status: "PENDING" | "ACCEPTED" | "REJECTED";
  emailStatus: "SENT" | "FAILED";
  expiresAt: string;
  createdAt: string;
  updatedAt: string;
}

interface Invitation {
  id: string;
  email: string;
  status: "PENDING" | "ACCEPTED" | "REJECTED";
  expiresAt: string;
  program: {
    id: string;
    commissionType: "PERCENTAGE";
    commissionValue: string;
    discountValue: string;
    minimumPayoutAmount: string;
    automaticApproval: boolean;
    status: "ACTIVE";
  };
  brandId: string;
  brandDetail: {
    id: string;
    companyName: string;
    brandProfileImage: string;
    website: string;
    description: string;
  };
}

export const affiliateService = {
  async getDetails(): Promise<AffiliateDetails> {
    const response = await affiliateApi.get<AffiliateDetails>('/affiliates/detail');
    return response.data;
  },

  async updateDetails(data: UpdateAffiliateDetails) {
    const response = await affiliateApi.put<AffiliateDetails>('/affiliates/detail', data);
    return response.data;
  },

  async getAffiliateAnalytics(days: number = 30) {
    const response = await affiliateApi.get(`/analytics/affiliate/overview?days=${days}`);
    return response.data;
  },
  async getAffiliateInvitations(): Promise<Invitation[]> {
    const response = await affiliateApi.get<Invitation[]>('/program/find-invitations');
    return response.data;
  },
  async resendVerificationEmail(affiliateId: string): Promise<{ success: boolean; message: string }> {
    const response = await affiliateApi.get(`/affiliates/resend-verification-email/${affiliateId}`);
    return response.data;
  },
  async verifyEmailCode(email: string, code: string): Promise<{ success: boolean; message: string }> {
    const response = await api.post('/affiliates/verify-email', { email, code });
    return response.data;
  },
  async getPostCheckoutSalesSummary(): Promise<{
    totalSales: number;
    totalCommissions: number;
    totalOrders: number;
    hasPostCheckoutSales: boolean;
  }> {
    const response = await affiliateApi.get('/affiliates/post-checkout-sales/summary');
    return response.data;
  },
}; 